import { useRef } from 'react'


const getUniqueId = ((id) => () => String(++id))(1)
const getRandomId = ((chars) => () => [ ...Array(4) ].map(() => chars[Math.floor(Math.random() * chars.length)]).join(''))('abcdefghijklmnopqrstuvwxyz0123456789')

const useUniqueId = (prefix = '', random = false) => {
  const id = useRef(`${prefix}${random ? getRandomId() : getUniqueId()}`)

  return id.current
}


export default useUniqueId
